/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { Availability } from './';
import {
    AvailabilityFromJSON,
    AvailabilityFromJSONTyped,
    AvailabilityToJSON,
} from './';
import type { PostalAddress } from './';
import {
    PostalAddressFromJSON,
    PostalAddressFromJSONTyped,
    PostalAddressToJSON,
} from './';
import type { WorkConditions } from './';
import {
    WorkConditionsFromJSON,
    WorkConditionsFromJSONTyped,
    WorkConditionsToJSON,
} from './';
import type { WorkingStatus } from './';
import {
    WorkingStatusFromJSON,
    WorkingStatusFromJSONTyped,
    WorkingStatusToJSON,
} from './';

/**
 * 
 * @export
 * @interface Remote
 */
export interface Remote extends WorkConditions {
    /**
     * 
     * @type {PostalAddress}
     * @memberof Remote
     */
    address?: PostalAddress;
}

/**
 * Check if a given object implements the Remote interface.
 */
export function instanceOfRemote(value: object): value is Remote {
    return true;
}

export function RemoteFromJSON(json: any): Remote {
    return RemoteFromJSONTyped(json, false);
}

export function RemoteFromJSONTyped(json: any, ignoreDiscriminator: boolean): Remote {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...WorkConditionsFromJSONTyped(json, ignoreDiscriminator),
        'address': json['address'] == null ? undefined : PostalAddressFromJSON(json['address']),
    };
}

export function RemoteToJSON(value?: Remote | null, ignoreDiscriminator?: boolean): any {
    if (value == null) {
        return value;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...WorkConditionsToJSON(value, true),
        'address': PostalAddressToJSON(value['address']),
    };
}

